import { render } from "./ThirdParties.vue?vue&type=template&id=71180dc7&scoped=true"
import script from "./ThirdParties.vue?vue&type=script&lang=js"
export * from "./ThirdParties.vue?vue&type=script&lang=js"

import "./ThirdParties.vue?vue&type=style&index=0&id=71180dc7&scoped=true&lang=scss"

import exportComponent from "/var/www/production/releases/343/listings.jumpfeed.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71180dc7"]])

export default __exports__